import { z } from 'zod';
import { c } from '../contract';
import { siteMapResponseSchema } from '../schemas';

export const recommendationsRouter = c.router(
  {
    siteMap: {
      summary: 'Load Tag Kinds & Slugs (Categories)',
      method: 'GET',
      path: '/site_map',
      query: z.object({ language: z.string() }),
      responses: {
        200: siteMapResponseSchema,
      },
    },
  },
  { pathPrefix: '/recommendations' },
);
